import { transcript } from './transcript';
import { wordsByVideo } from './words-by-video';

export const subtitlesApi = {
  transcript,
  wordsByVideo,
};
